import React from 'react'
import styled, { css } from 'styled-components'

export const AccordionSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  opacity: 1;

  ${({ isCartOnProductsList }) => isCartOnProductsList && css`
    position: sticky;
    top: 20px;
  `}

  &:last-child {
    border-bottom: 0;
    margin-bottom: 10px;
  }
`

export const Accordion = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: ${({ isClosed }) => isClosed ? 'not-allowed' : 'pointer'};
  transition: background-color 0.6s ease;
  position: relative;
  padding: 10px 0px;
  box-sizing: border-box;

  ${props => props.isClosed && css`
    background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5));
    padding: 10px 5px;
  `}

  .rotate {
    transform: rotate(180deg);
  }

  .accordion__icon {
    transition: transform 0.6s ease;
  }
`

export const ContentInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  ${({ isLogo }) => isLogo && css`
    width: calc(100% - 80px);
  `}

  > div {
    display: flex;
    align-items: center;

    .go-store {
      user-select: none;
      color: ${props => props.theme.colors.primary};
      margin-right: 5px;
      ${props => props.theme?.rtl && css`
        margin-left: 5px;
        margin-right: 0;
      `}
      &:hover {
        text-decoration: underline;
      }
    }
    .clear-cart {
      user-select: none;
      color: #000;
      opacity: 0.8;
      margin-left: 5px;
      ${props => props.theme?.rtl && css`
        margin-right: 5px;
        margin-left: 0;
      `}
      &:first-letter {
        text-transform: uppercase;
      }
      &:hover {
        text-decoration: underline;
      }
    }

    ${({ isStore }) => isStore && css`
      .clear-cart {
        margin: 0px;
      }
    `}
  }
  .change-store {
    cursor: pointer;
    color: ${props => props.theme.colors.primary};
    font-size: 12px;
    &:first-letter {
      text-transform: uppercase;
    }
    &:hover {
        text-decoration: underline;
      }
  }
  ${props => props.theme?.rtl && css`
    margin-right: 10px;
    margin-left: 0;
  `}

  span {
    cursor: pointer;
  }

  span.danger{
    color: ${({ theme }) => theme?.colors?.danger500};
  }

  h2, span {
    margin: 0px;
  }

  h2 {
    color: #000;
    font-size: 16px;
    font-weight: 500;
  }

  @media (min-width: 576px) {
    h2 {
      font-size: 18px;
    }
    span {
      font-size: 13px;
    }
  }
`

export const AccordionContent = styled.div`
  overflow: hidden;
  transition: min-height 0.6s ease;
`

export const AccordionText = styled.div`
  font-weight: 400;
  font-size: 14px;
  padding: 18px;
`

export const BusinessInfo = styled.div`
  display: flex;
  align-items: center;
  width: calc(100% - 30px);
  ${({ isOtherInfo }) => isOtherInfo && css`
    width: calc(100% - 100px);
  `}

  h2 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`

export const BusinessTotal = styled.div`
  width: ${({ isCartOnProductsList }) => isCartOnProductsList ? '30%' : '25%'};
  display: none;
  flex-direction: column;
  align-items: center;

  p {
    font-size: 13px;
    margin: 0px 5px;
    font-weight: 300;

    &:nth-child(1) {
      font-weight: 500;
    }
  }

  &.closed {
    flex: 1;
    p {
      text-align: center;
      margin: 0px 20px;
      font-size: 13px;
    }
  }

  @media (min-width: 481px) {
    display: flex;
  }
`

export const BusinessActions = styled.div`
  max-width: 30px;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  span {
    height: 22px;
    svg {
      font-size: 22px;
    }

    &:not(:last-child) {
      margin-right: 5px;
      ${props => props.theme?.rtl && css`
        margin-left: 5px;
        margin-right: 0;
    `}
    }
  }

  @media (min-width: 768px) {
    span {
      height: 27px;
      svg {
        font-size: 27px;
      }
    }
  }
`

export const PriceContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;

  h4 {
    font-size: 16px;
    flex-shrink: 0;
    color: #000;
  }

  button {
    padding: 10px 15px;
    min-width: 150px;
    max-width: 70%;
    min-height: 50px;
    height: auto;
    white-space: normal;
    word-wrap: break-word;
    overflow-wrap: break-word;
    hyphens: auto;
    text-align: center;
    line-height: 1.3;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      margin-left: 3px;
      white-space: nowrap;
    }

    @media (max-width: 1400px) {
      padding: 8px 12px;
      font-size: 13px;
      min-height: 45px;
    }

    @media (max-width: 1200px) {
      padding: 8px 10px;
      font-size: 12px;
      min-height: 42px;
    }

    @media (max-width: 768px) {
      padding: 8px 16px;
      min-width: 120px;
      max-width: 65%;
      min-height: 45px;
      font-size: 12px;
    }

    @media (max-width: 480px) {
      padding: 6px 12px;
      min-width: 100px;
      max-width: 60%;
      min-height: 40px;
      font-size: 11px;
    }

    @media (max-width: 360px) {
      padding: 5px 8px;
      min-width: 80px;
      max-width: 55%;
      min-height: 35px;
      font-size: 10px;
    }
  }
`

const BusinessLogoStyled = styled.div`
  display: flex;
  width: 75px;
  height: 75px;
  min-height: 75px;
  box-sizing: border-box;
  position: relative;
  background-repeat: no-repeat, repeat;
  background-size: contain;
  object-fit: contain;
  background-position: center;
  border-radius: 10px;
`

export const BusinessLogo = (props) => {
  return (
    <BusinessLogoStyled
      {...props}
      style={{ backgroundImage: `url(${props.bgimage})` }}
    >
      {props.children}
    </BusinessLogoStyled>
  )
}

export const WrapperBusinessLogo = styled.div`
  max-width: 75px;
  max-height: 75px;
  height: 75px;
  width: 75px;
  margin-right: 10px;
`

export const TimeContainer = styled.div`
  svg{
    position: relative;
    top: 1px;
    margin-right: 5px;
  }
`
